import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

export const rolesGuard: CanActivateFn = 
  async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const authService = inject(AuthService);
    if (route.data && route.data['roles']) {
      if (!authService.hasRole(route.data['roles'])) {
        const router = inject(Router);
        router.navigate(['/']);
        return false;
      }
    }
    return true;
};
